module.exports = __webpack_public_path__ + "static/index_portier-d84b691fcb83e6dbf45071881c8a1a42.jpg";